import { render, staticRenderFns } from "./HomeNewsDetail.vue?vue&type=template&id=0eb09d8c&scoped=true"
import script from "./HomeNewsDetail.vue?vue&type=script&lang=js"
export * from "./HomeNewsDetail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0eb09d8c",
  null
  
)

export default component.exports